import type { Metadata } from '@lumapps/metadata/types';
import type { Fields } from '@lumapps/utils/types/Fields';

export const DEFAULT_METADATA_PICKER_REQUEST_FIELDS: Fields<Metadata> = [
    'id',
    'name',
    'parent',
    'sortOrder',
    'familyKey',
];
export const DEFAULT_SCOPE = 'metadata-picker';
export const DEFAULT_SCOPE_MULTIPLE = 'metadata-picker-multiple';
